<template>
  <header class="">
    <Header />
  </header>
  <main class="container content-wrapper p-2">
    <router-view />
  </main>
</template>

<script>
import Header from "@/components/layout/Header.vue";

export default {
  name: "AppView",
  data() {
    return {};
  },
  components: {
    Header,
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style>
:root {
  --lm-base-body-bg-color: var(--pink-color-very-light);
  --lm-navbar-bg-color: var(--pink-color-light);
  --lm-button-secondary-bg-color: var(--pink-color-light);
  --lm-button-secondary-border-color: var(--pink-color-light);
  --lm-navbar-link-text-color-hover: var(--black-color);
}
</style>
